import React from "react"
import "./frames.css"

const Instalacion = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">Instalación de Cámaras Perry</h1>
      <p className="frames-text">
        Nuestro equipo especializado se encarga de la instalación completa de
        cámaras Perry en hospitales y centros de tratamiento en España, Portugal
        y gran parte de los países de Europa. Aseguramos una instalación rápida,
        eficaz y conforme a todas las normativas de seguridad.
      </p>
      <h2 className="frames-subtitle">Enfoque en Seguridad</h2>
      <p className="frames-text">
        Seguimos rigurosas medidas de seguridad durante el proceso de
        instalación para garantizar la integridad del equipo y del personal
        médico.
      </p>
    </div>
  )
}

export default Instalacion
